import { render, staticRenderFns } from "./LandPagePartner.vue?vue&type=template&id=28d4f41c&scoped=true"
import script from "./LandPagePartner.vue?vue&type=script&lang=js"
export * from "./LandPagePartner.vue?vue&type=script&lang=js"
import style0 from "./LandPagePartner.vue?vue&type=style&index=0&id=28d4f41c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4f41c",
  null
  
)

export default component.exports